import { gql } from '../../../__generated__/graphql/catalog'

export const FETCH_CART = gql(`
  query cart($cartId: String!) {
    cart(cartId: $cartId) {
      cart {
        id
      }
    }
  }
`)
